const url = process.env.REACT_APP_ENV === 'DEV';
const Config = {
  BaseURL: url ? process.env.REACT_APP_BASE_API_URL : `${window.location.protocol}//${window.location.hostname}`,
  // BaseURL: 'https://dev-admin.bookbanquetroom.com',
  DeleteDelay: 3000,
  DefaultLimit: 10,
  REACT_APP_CLIENT: 'bbradmin',
  REACT_APP_SECRET: 'bbr#234',
};

export default Config;
